import { render, staticRenderFns } from "./partner-add-transporter-form.vue?vue&type=template&id=0bb4b44e"
import script from "./partner-add-transporter-form.vue?vue&type=script&lang=js"
export * from "./partner-add-transporter-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports